var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"d-flex py-0 pt-2"},[_c('p',{staticClass:"overline my-0 mr-1"},[_vm._v("BIC")]),_vm._v(" "),_c('p',{staticClass:"title flex-grow-0 mb-0 font-weight-bold"},[_vm._v(_vm._s(_vm.recipientInfo.bic))])])}
var staticRenderFns = []

export { render, staticRenderFns }